import React, { useId } from 'react'
import PropTypes from 'prop-types'

const PointerFillIcon = React.forwardRef(function PointerFillIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M20.59 7.20996L19.7199 6.31006C18.6399 5.21006 18.37 5.03001 17.01 5.01001H2.99998C2.20433 5.01001 1.44125 5.32606 0.878638 5.88867C0.316029 6.45128 -2.3976e-05 7.21436 -2.3976e-05 8.01001V16.01C-0.00552134 16.4062 0.0696364 16.7993 0.220923 17.1655C0.37221 17.5317 0.596466 17.8633 0.879981 18.14C1.44205 18.7028 2.20459 19.0193 2.99998 19.02H17.14C18.34 19.02 18.61 18.79 19.58 17.85L19.7 17.74C22.93 14.59 23.98 13.45 24 12.03C24.02 10.61 23.09 9.75996 20.59 7.20996Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

PointerFillIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

PointerFillIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default PointerFillIcon
